import {FxeQuizQuestionController} from "./FxeQuizQuestionController";
import {MARKET_MOVEMENT_VOL} from "../FxeQuizQuestions";
import {UserConfig} from "../../../types/UserConfig";
import {CurrentUserService} from "../../../services/user/CurrentUserService";

export const MarketMovementVol = "tfMarketMovementVolQuestion";

export function marketMovementVol() {
    return {
        templateUrl: "app/quiz/fxe/questions/MarketMovementVol.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: MarketMovementVolController
    };
}

export class MarketMovementVolController extends FxeQuizQuestionController {
    public config = MARKET_MOVEMENT_VOL;
}
